// @flow
import styled from 'styled-components';
import colors from '../../assets/css/colors';

export const TransactionPlayers = styled.div`
	flex-basis: 30%;
	> div {
		margin-bottom: 10px;
		box-shadow: 0 0 2px 0 rgba(0,0,0,0.15);
	}
	> p {
		color: ${colors.darkGrey};
		font-size: 13px;
		line-height: 1.46;
		margin-bottom: 5px;
	}
`;

export default TransactionPlayers;


// WEBPACK FOOTER //
// ./src/components/Trades/TransactionPlayers.js